<template>
  <div class="header-default">
    <div class="header-wrap w1200">
      <div class="site-info">
        <div class="site-l">
          <img class="site-logo" src="~@/assets/images/site_logo.png" alt="">
          <span class="site-store-name">元素魔方商城</span>
        </div>
        <div class="site-R">
          <div class="search-box">
            <input type="text" class="search-inp" placeholder="请输入您想搜索的内容">
            <img class="search-icon" src="~@/assets/images/header_search_icon.png" alt="">
          </div>
          <span class="site-scene fs20 fwn follow-us">
            关注我们
            <div class="follow-qrcode">
              <img src="https://www.jiazhouhuashi.cn/static/img/wxmp.24025509.jpg" alt="">
            </div>
          </span>
          <span class="site-scene fs20 fwn">|</span>

          <template v-if="token">
            <div class="login-info">
              <router-link :to="{ path: '/user/index' }" class="info">
                <img class="avatar" :src="avatar" alt="" />
                <span>个人中心</span>
              </router-link>
              <a @click="logout" class="logout">退出</a>
              <!-- <img class="avatar" src="~@/assets/images/avatar.png" alt="">
              <span>{{ phone }}</span>
              <ul class="popup">
                <li><router-link :to="{ path: '/user/index' }">个人中心</router-link></li>
                <li><a @click="logout">退出登录</a></li>
              </ul> -->
            </div>
          </template>
          <template v-else>
            <span class="site-scene fs20 fwn"><router-link :to="{ path: '/auth/login' }">登录</router-link></span>
            <div class="register-btn fs20 fwn">
              <router-link :to="{ path: '/auth/register' }">免费注册</router-link>
            </div>
          </template>

          <!-- <span class="site-scene fs20 fwn"><a href="~@/assets/login.html">登录</a></span>
          <div class="register-btn fs20 fwn">
            <a href="../register.html">免费注册</a>
          </div> -->
        </div>
      </div>
      <div class="store-nav">
        <ul class="store-tabs">
          <li><a :href="`${domain}/store.html`">首页</a></li>
          <li><a :href="`${domain}/store/goods.html`">产品</a></li>
          <li><a :href="`${domain}/store/integral.html`">积分兑换</a></li>
        </ul>
        <div class="nav-r">
          <router-link class="fast-order" :class="[path == '/store_order/fast' ? 'active' : '']"
            :to="{ path: '/store_order/fast' }">快速订购</router-link>
          <p class="store-car"><img src="~@/assets/images/store_car_icon.png" alt=""><router-link
              :to="{ path: '/store_order/add' }">购物车</router-link></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "StoreHeader",
  components: {

  },
  props: {

  },
  computed: {
    ...mapGetters(["token", "name", "phone", "avatar", "path"])
  },
  data() {
    return {
      domain: process.env.VUE_APP_DOMAIN,
    };
  },
  created() {
    console.log(process.env.VUE_APP_DOMAIN);
  },
  methods: {
    logout() {
      this.$store.dispatch("Logout");
      this.$message.success("退出成功");
      this.$router.push("/auth/login");
    }
  }
};
</script>
<style lang="scss" scoped>
.header-default {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: white;
  box-shadow: 0px 5px 15px 1px #ccd7db;
  -moz-box-shadow: 0px 5px 15px 1px #ccd7db;
  -webkit-box-shadow: 0px 5px 15px 1px #ccd7db;

  .header-wrap {
    padding-top: 18px;

    .site-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 21px;

      .site-scene {
        line-height: 20px;
        color: #222222;
      }

      .follow-us {
        position: relative;

        .follow-qrcode {
          display: none;
          position: absolute;
          bottom: -180px;
          left: -50px;
          z-index: 9;
          padding: 5px;
          border-radius: 4px;
          border: solid 1px rgba(0, 0, 0, 0.15);
          background-color: white;
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);

          img {
            width: 150px;
            height: 150px;
          }

          &::after {
            content: "";
            position: absolute;
            top: -10px;
            left: 50%;
            margin-left: -10px;
            transform: rotate(45deg);
            width: 20px;
            height: 20px;
            background-color: #FFF;
            border-left: 1px solid #ccc;
            border-top: 1px solid #ccc;
          }
        }
      }

      .follow-us:hover .follow-qrcode {
        display: block;
      }

      .isLogin {
        display: flex;
        align-items: center;
        column-gap: 8px;
        font-size: 20px;
        font-weight: 400;
        color: #00B4E8;

        .is-login-icon {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          border: 1px solid #00B4E8;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #00B4E8;
          font-size: 15px;
        }
      }

      .site-l {
        display: flex;
        align-items: center;
        column-gap: 17px;

        .site-logo {
          width: 53px;
          height: 53px;
        }

        .site-name {
          color: #222222;
        }

        .site-store-name {
          font-size: 24px;
          font-weight: 400;
          color: #00b4e8;
        }
      }

      .site-R {
        display: flex;
        align-items: center;
        column-gap: 17px;

        span {
          cursor: pointer;
        }

        .search-box {
          width: 337px;
          height: 40px;
          border-radius: 25px;
          border: 1px solid #ccd7db;
          padding: 0 25px 0 17px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .search-inp {
            width: 258px;
            outline: none;
            border: none;
            margin-top: 3px;
          }

          .search-icon {
            width: 25px;
            height: 25px;
            cursor: pointer;
          }
        }

        .login-info {
          display: flex;
          flex-direction: row;
          justify-items: center;
          align-items: center;
          position: relative;
          font-size: 18px;

          .info {
            display: flex;
            flex-direction: row;
            justify-items: center;
            align-items: center;

            .avatar {
              width: 32px;
              height: 32px;
              margin-right: 10px;
              border-radius: 50%;
            }
          }

          a {
            color: #00b4e8;

            &.logout {
              margin-left: 10px;
            }
          }

          &:hover .popup {
            display: block;
          }

          .popup {
            position: absolute;
            bottom: -100px;
            left: 50%;
            width: 120px;
            margin-left: -60px;
            display: none;
            border-radius: 4px;
            border: solid 1px rgba(0, 0, 0, 0.15);
            background-color: white;
            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
            z-index: 999;
            padding: 10px;

            &::after {
              content: "";
              position: absolute;
              top: -10px;
              left: 50%;
              margin-left: -10px;
              transform: rotate(45deg);
              width: 20px;
              height: 20px;
              background-color: #fff;
              border-left: 1px solid #ccc;
              border-top: 1px solid #ccc;
            }

            li {
              width: 100%;
              margin: 10px 0;
              display: inline-block;
              text-align: center;
            }
          }
        }

        .register-btn {
          height: 40px;
          padding: 0 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #00b4e8;
          color: white;
          border-radius: 28px;
          cursor: pointer;
        }
      }
    }

    .store-nav {
      margin-top: 21px;
      display: grid;
      grid-template-columns: auto 295px;
      align-items: center;
      justify-content: space-between;
      column-gap: 50px;

      .store-tabs {
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        height: 65px;
        font-size: 20px;
        font-weight: 400;
        color: #222222;

        .sel-tab {
          font-size: 20px !important;
          font-weight: bold !important;
          color: #ffffff !important;
          background: #00b4e8 !important;
        }

        &>li {
          width: 179px;
          height: 65px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .nav-r {
        font-size: 20px;
        font-weight: 400;
        color: #222222;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        .store-car {
          display: flex;
          align-items: center;
          column-gap: 10px;
        }

        .fast-order {
          width: 170px;
          height: 65px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .active {
          color: #ffffff;
          background-color: #00b4e8;
        }
      }
    }

    .tabs {
      margin-top: 40px;
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      height: 40px;
      // column-gap: 43px;
      color: #222222;
      white-space: nowrap;
      position: relative;
      justify-content: space-between;
      .sel-tab {
        color: #00b4e8;
        font-weight: 500;
        position: relative;
      }

      .sel-tab::after {
        content: "";
        width: 100%;
        height: 2px;
        position: absolute;
        left: 0px;
        bottom: 0px;
        background-color: #00b4e8;
      }

      &>li {
        cursor: pointer;
      }
    }

    .tabs::-webkit-scrollbar {
      height: 0;
    }
  }
}
</style>